@if (quoteListDetails) {
  <div class="row col-12 col-sm-12 manage-user-container">
    <div class="col-3 col-sm-3 left-side">
      <app-my-account-left-sidenav [navState]="'MyQuotesNavNode'"
      [childNavState]="'MyQuotesNavNode'"></app-my-account-left-sidenav>
    </div>
    <div class="myAccountMyProfile col-9 col-sm-9 right-side">
      <h1 class="manageUserTopHeader m-0">{{'common.text_account_quote_myquotes'|cxTranslate}}
      </h1>
      <div class="form-field-control edit-user-form-control my-section-box-inner">
        <div class="mt-3">
          <form [formGroup]="quoteListForm" (click)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()">
            <ng-container>
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="container-cus-block">
                  <div class="acc-sec-content">
                    <label class="control-label">{{'common.order_history_customer_ID'|cxTranslate}}</label>
                    <div class="select">
                      <select name="customer" (change)="searchQuote()" id="customerId" formControlName="customerId">
                        @for (opt of $any(quoteListDetails)?.b2bUnitsWSList; track opt) {
                          <option [value]="opt?.uid"
                            [ngClass]="opt?.orderBlocked ? 'bgGrey' : ''">
                            @if (opt?.addresses && opt?.addresses[0]?.sapCustomerID) {
                              <span> {{
                              opt?.addresses[0]?.sapCustomerID }}&nbsp;|&nbsp;</span>
                            }
                            @if (opt?.salesArea2) {
                              <span> {{ opt?.salesArea2|cxTranslate }}&nbsp;|&nbsp;</span>
                            }
                            @if (opt?.addresses && opt?.addresses[0]?.companyName) {
                              <span> {{
                                opt?.addresses[0]?.companyName
                              }}&nbsp;|&nbsp;</span>
                            }
                            @if (opt?.addresses && opt?.addresses[0]?.formattedAddress) {
                              <span> {{
                              opt?.addresses[0]?.formattedAddress }}</span>
                            }
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            @if ($any(quoteListDetails)?.results.length==0) {
              <div class="sort-section d-flex justify-content-center">
                <div class="row">
                  <div class="account-section-content content-empty">
                  {{'common.text_account_quotes_noQuotes'|cxTranslate}}</div>
                </div>
              </div>
            }
          </form>
        </div>
      </div>
      @if (quoteListDetails && quoteListDetails.results?.length>0) {
        <div class="sort-section my-section-box">
          <div class="gray-search-result-box">
            {{totalResults}}
          </div>
          <div class="order-status-table mycompany-manageUser">
            <table class="responsive-table table table-bordered table-blue">
              <thead>
                <tr class="responsive-table-head hidden-xs hidden-sm">
                  <th scope="col">
                    <span>{{'common.text_account_quote_name'|cxTranslate}}</span>
                  </th>
                  <th scope="col">
                    <span>{{'common.text_account_quote_code'|cxTranslate}}</span>
                  </th>
                  <th scope="col" class="f-s">
                    <span>{{'common.text_account_quote_status'|cxTranslate}}</span>
                  </th>
                  <th scope="col" class="f-s">
                    <span>{{'common.text_account_quote_c4c_comment_header'|cxTranslate}}</span>
                  </th>
                  <th scope="col" class="f-s">
                    <span>{{'common.text_account_quote_date_placed'|cxTranslate}}</span>
                  </th>
                  <th scope="col" class="f-s">
                    <span>{{'common.text_account_quote_date_updated'|cxTranslate}}</span>
                  </th>
                </tr>
              </thead>
              @if (quoteListDetails) {
                <tbody>
                  @for (item of quoteListDetails?.results; track item) {
                    <tr class="responsive-table-item">
                      <td class="responsive-table-cell name">
                        <a [routerLink]="['/my-quotes',item.code]" (click)="redirectOrder(item)"><span
                        class="mycompnay-registration-value pointer">{{item.name}}</span></a>
                      </td>
                      <td class="responsive-table-cell email">
                        <span class="mycompnay-registration-value">{{item.code}}</span>
                      </td>
                      <td class="responsive-table-cell email">
                        <span class="mycompnay-registration-value pointer">{{item.quoteState?.name}}</span>
                      </td>
                      <td class="responsive-table-cell email">
                        <span class="mycompnay-registration-value pointer">{{item.comments[0]}}</span>
                      </td>
                      <td class="responsive-table-cell email">
                        <span class="mycompnay-registration-value">{{formatDate(item.creationTime)}}</span>
                      </td>
                      <td class="responsive-table-cell email">
                        <span class="mycompnay-registration-value">{{formatDate(item.updatedTime)}}</span>
                      </td>
                    </tr>
                  }
                </tbody>
              }
            </table>
          </div>
          <div class="account-orderhistory-pagination company-users-pagination">
            <div class="product__list--wrapper">
              <div class="pagination-bar">
                <div class="pagination-toolbar">
                  <div class="row sort-refine-bar">
                    <div class="col-xs-12 col-sm-6 col-md-6 bottom-result">
                      <div class="pagination-result">
                      {{pageItems}} </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 kb-pagination-right kb-pagination">
                      <kb-pagination [pagination]="quoteListDetails?.pagination" [defaultPage]="0"
                      (viewPageEvent)="changePageCustom($event)"></kb-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}